import { makeStyles } from "@mui/styles";
import { COLORS } from "../../../constant/colors";

export default makeStyles(() => ({
  testimonialsSec: {
    padding: "100px 0",
    background: COLORS.coralDark,
    marginBottom: 0,
    position: "relative",
    "@media (max-width: 600px)": {
      padding: "40px 0",
    },
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "40px",
      backgroundImage: "url('/images/footer-wave.svg')",
      backgroundSize: "auto 100%",
      backgroundRepeat: "repeat-x",
      backgroundPosition: "top center",
      zIndex: 1,
    },
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      height: "40px",
      backgroundImage: "url('/images/footer-wave.svg')",
      backgroundSize: "auto 100%",
      backgroundRepeat: "repeat-x",
      backgroundPosition: "bottom center",
      transform: "rotate(180deg)",
      zIndex: 1,
    },
    "@media (max-width: 767px)": {
      padding: "60px 0",
      "&::before": {
        height: "25px",
      },
      "&::after": {
        height: "25px",
      },
    },
  },
  sectionHeader: {
    textAlign: "center",
    marginBottom: 20,
    position: "relative",
    zIndex: 2,
    "@media (max-width: 600px)": {
      marginBottom: 10,
    },
  },
  heading: {
    fontSize: "2.5rem",
    fontWeight: 700,
    color: COLORS.white,
    marginBottom: '20px !important',
    fontFamily: "'Poppins', sans-serif",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: -12,
      left: "50%",
      transform: "translateX(-50%)",
      width: 60,
      height: 4,
      background: COLORS.white,
      borderRadius: 2,
    },
    "@media (max-width: 600px)": {
      fontSize: "1.8rem",
      marginBottom: 12,
    },
  },
  subheading: {
    fontSize: "1rem",
    color: COLORS.white,
    opacity: 0.9,
    maxWidth: 600,
    margin: "0 auto !important",
    lineHeight: 1.6,
    fontFamily: "'Poppins', sans-serif",
    "@media (max-width: 600px)": {
      fontSize: "0.9rem",
    },
  },
  carouselContainer: {
    maxWidth: 1200,
    margin: "0 auto",
    padding: "0 20px",
    "@media (max-width: 600px)": {
      padding: "0",
    },
  },
  carousel: {
    padding: "20px 0",
    "& .react-multi-carousel-item": {
      padding: "0 15px",
    },
    "& .react-multiple-carousel__arrow--left": {
    },
    "& .react-multiple-carousel__arrow--right": {
    },
  },
  testimonialCard: {
    background: COLORS.white,
    borderRadius: 20,
    padding: "32px 24px",
    // boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
    transition: "all 0.3s ease",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "&:hover": {
      transform: "translateY(-4px)",
      // boxShadow: "0 16px 40px rgba(0, 0, 0, 0.12)",
    },
  },
  testimonialHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: 24,
  },
  customerImage: {
    width: 60,
    height: 60,
    borderRadius: "50%",
    overflow: "hidden",
    marginRight: 16,
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
  },
  customerInfo: {
    flex: 1,
  },
  customerName: {
    fontSize: "1.1rem",
    fontWeight: 600,
    color: COLORS.textPrimary,
    marginBottom: 4,
    fontFamily: "'Poppins', sans-serif",
  },
  customerLocation: {
    fontSize: "0.9rem",
    color: COLORS.textSecondary,
    marginBottom: 8,
    fontFamily: "'Poppins', sans-serif",
  },
  rating: {
    display: "flex",
    gap: 2,
  },
  star: {
    width: 16,
    height: 16,
  },
  testimonialContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  testimonialComment: {
    fontSize: "1rem",
    color: COLORS.textSecondary,
    lineHeight: 1.6,
    marginBottom: 16,
    fontStyle: "italic",
    fontFamily: "'Poppins', sans-serif",
    "@media (max-width: 600px)": {
      fontSize: "0.9rem",
    },
  },
  productTag: {
    marginTop: "auto",
    "& span": {
      background: `linear-gradient(135deg, ${COLORS.saffron} 0%, ${COLORS.saffronLight} 100%)`,
      color: COLORS.white,
      padding: "6px 12px",
      borderRadius: 20,
      fontSize: "0.8rem",
      fontWeight: 500,
      fontFamily: "'Poppins', sans-serif",
    },
  },
}));
